import { REHYDRATE } from 'redux-persist/lib/constants';
import { handleActions } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

export const appState = {
  list: [],
  pages: 0,
  currentPage: 0,
  loading: false,
};

export default {
  newFeature: handleActions(
    {
      [REHYDRATE]: draft => {
        draft.list = [];
      },
      [ActionTypes.GET_NEW_FEATURES_REQUEST]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_NEW_FEATURES_SUCCESS]: (
        draft,
        {
          payload: {
            result,
            metadata: { totalPages, currentPage },
          },
        },
      ) => {
        draft.list = result;
        draft.pages = totalPages;
        draft.currentPage = currentPage;
        draft.loading = false;
      },
      [ActionTypes.GET_NEW_FEATURES_FAILURE]: draft => {
        draft.loading = false;
      },
    },
    appState,
  ),
};
